import { SuperJSONResult } from 'superjson';
import {
  Form,
  FormType,
  WindowState,
} from '../../components/global-forms/GlobalForms.types';

export interface FormInfo {
  id: number;
  form: Form;
  values?: SuperJSONResult;
  showDetails?: boolean;
}

export interface UpdateFormValues {
  id: number;
  values: { [key: string]: any };
  showDetails?: boolean;
}

export interface UpdateFormState {
  id: number;
  state: WindowState;
}

export interface UpdateShowDetails {
  id: number;
  showDetails: boolean;
}

export interface DataBlockInfo {
  tabId: string;
  id: number;
  showDetails: boolean;
  values: SuperJSONResult;
  type: 'update_patient_block' | 'update_data_block';
}

export interface RemoveDataBlock {
  tabId: string;
  id: number;
  type: 'update_patient_block' | 'update_data_block';
}

export interface DocumentTemplateInfo {
  tabId: string;
  templateId: number | null;
  content: string;
}

export type UnsavedChangesState = {
  globalForms: FormInfo[];
  dataBlocks: DataBlockInfo[];
  documentTemplates: DocumentTemplateInfo[];
};

export const defaultUnsavedChangesState: UnsavedChangesState = {
  globalForms: [],
  dataBlocks: [],
  documentTemplates: [],
};

export const enabledFormTypes: FormType[] = [
  'createPatient',
  'editPatient',
  'createVisit',
  'editVisit',
  'createDataBlock',
  'editDataBlockStatistic',
];
